import React from 'react';
import { Divider, Flex, Skeleton } from '@chakra-ui/react';
import { storageComponentSx } from '../styles';

export const StorageLoader = () => {
  return (
    <Flex sx={storageComponentSx.root}>
      <Flex sx={storageComponentSx.planWrapper}>
        <Skeleton height="18px" width="74px" />
        <Flex sx={storageComponentSx.planDetails}>
          <Skeleton height="16px" width="50px" mb="5px" />
          <Skeleton height="14px" />
        </Flex>
      </Flex>
      <Divider
        orientation="vertical"
        display={{ base: 'none', display: 'block' }}
      />
      <Flex sx={storageComponentSx.widgetWrapper}>
        <Skeleton height="19px" width="112px" mb={3} />
        <Skeleton height="52px" mb="6px" />
      </Flex>
      <Flex ml="auto">
        <Skeleton
          width="88px"
          height="28px"
          sx={storageComponentSx.subscriptionButton}
        />
      </Flex>
    </Flex>
  );
};
